export default {
    "alerts": {
        "alerts": "Alertes",
        "createAlert": "Créer une alerte",
        "manageAlerts": "Gérer les alertes",
        "alertAlreadyExists": "Une alerte avec ce nom existe déjà. Voulez-vous la remplacer ?"
    },

    "editAlert": {
        "title": "Alerte",
        "name": "Nom",
        "frequency": "Fréquence",
        "days": "Jours",
        "monday": "lundi",
        "tuesday": "mardi",
        "wednesday": "mercredi",
        "thursday": "jeudi",
        "friday": "vendredi",
        "saturday": "samedi",
        "sunday": "dimanche",
        "times": "Horaires",
        "active": "Active",
        "updateQuery": "Mettre à jour la requête",
        "runQuery": "Exécuter la requête",
        "lossDataMessage": "Voulez-vous quitter sans sauvegarder vos modifications ?"
    },

    "manageAlerts": {
        "title": "Gérer les alertes",
        "edit": "Editer",
        "reorder": "Réorganiser",
        "remove": "Effacer",
        "removeAll": "Effacer tout"
    },

};
